// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"265":"89dbdaf15b83f06b","453":"9f3510ad02ceb71f","874":"3c15516b63e81a1c"}[chunkId] + ".js";
};